import {type Component, defineAsyncComponent} from 'vue';

import {SupportProgramAddonSlug} from "@/program/interfaces/addons";

const registry: Record<SupportProgramAddonSlug, Component> = {
    [SupportProgramAddonSlug.Pets]: defineAsyncComponent(
        () => import('@/program/components/support-program-addons/pets/CustomerProgramPets.vue')
    ),
    [SupportProgramAddonSlug.VaccinationTimeline]: defineAsyncComponent(
        () => import('@/program/components/support-program-addons/vaccination/VaccinationTimeline.vue')
    ),
    [SupportProgramAddonSlug.FLOWCHART]: defineAsyncComponent(
        () => import('@/program/components/support-program-addons/flowchart/Flowchart.vue')
    ),
    [SupportProgramAddonSlug.FLOWCHART_GROUP]: defineAsyncComponent(
        () => import('@/program/components/support-program-addons/flowchart/FlowchartGroup.vue')
    ),
    [SupportProgramAddonSlug.SURVEY]: defineAsyncComponent(
        () => import('@/program/components/support-program-addons/survey/SurveyAddon.vue')
    )
};

export const resolveAddon = (slug: SupportProgramAddonSlug): Component | undefined => registry[slug];
